import styled from 'styled-components';

const Noselect = styled.div`
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
   user-select: none;
`;

export default Noselect